import axios from 'axios';

// const getTranslationFor = ({ msgid, defaultLabel }) => {
//   return getTranslationCatalog().then(catalog => {
//     if (!catalog) {
//       return '';
//     }
//     const { data } = catalog;
//     return data[msgid] ? data[msgid] : defaultLabel;
//   });
// };

export const getTranslationCatalog = (domain = 'unife.iuss') => {
  const catalogUrl = document
    .querySelector('body')
    .getAttribute('data-i18ncatalogurl');
  if (!catalogUrl) {
    return new Promise(function(resolve) {
      resolve(null);
    });
  }
  var language = document.querySelector('html').getAttribute('lang');
  if (!language) {
    language = 'en';
  }
  //const domain = 'unife.policy';
  return axios({
    method: 'GET',
    url: catalogUrl,
    params: { domain, language },
  })
    .then(({ data }) => {
      return { ...data, language };
    })
    .catch(function(error) {
      // handle error
      console.log(error);
    });
};
